import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
export const RadioButton = /*#__PURE__*/forwardRef(
/**
 *
 * @param {object} props
 * @param {string} props.id
 * @param {string} props.name
 * @param {"small" | "regular"} [props.size]
 * @param {any} [props.className]
 * @param {string | number} props.value
 * @param {boolean | string | number} props.current
 * @param {boolean} [props.disabled]
 * @param {string} [props.title]
 * @param {boolean} [props.required]
 * @param {(e: MouseEvent) => any} [props.onChange]
 * @param {boolean} [props.noSpanClick]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function RadioButton({
  id,
  name,
  size,
  className,
  value = "",
  current = "",
  disabled = false,
  title,
  required,
  onChange,
  noSpanClick
}, ref) {
  const checked = value === current;
  const checkboxClasses = classNames(["border-2 radio inline-block cursor-pointer text-center font-bold"], {
    disabled,
    checked,
    "border-en-gray-400": disabled && !checked,
    "bg-en-gray-400 text-white": disabled && checked,
    "bg-en-yellow-700 text-white border-en-yellow-700": !disabled && checked,
    "border-en-gray-600": !disabled && !checked,
    "radio-small": size === "small"
  }, className);

  const spanClickHandler = e => {
    e.target.value = value;
    !noSpanClick && !disabled && changeHandler(e);
  };

  const changeHandler = e => {
    if (typeof onChange === "function") {
      onChange(e);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: checkboxClasses,
    onClick: spanClickHandler
  }), /*#__PURE__*/React.createElement("input", {
    id: id,
    name: name,
    type: "radio",
    style: {
      display: "none"
    },
    required: required,
    value: value,
    checked: checked,
    title: title,
    disabled: disabled,
    "aria-label": title,
    "aria-required": required,
    onChange: changeHandler,
    ref: ref
  }));
});
export const Radio = /*#__PURE__*/forwardRef(
/**
 *
 * @param {object} props
 * @param {string} [props.label]
 * @param {any} [props.className]
 * @param {string} props.id
 * @param {string} props.name
 * @param {"small" | "regular"} [props.size]
 * @param {string | number} props.value
 * @param {boolean | string | number} props.current
 * @param {object} [props.disabled]
 * @param {string} [props.title]
 * @param {object} [props.required]
 * @param {object} [props.onChange]
 * @param {object} [props.noSpanClick]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function Radio({
  label,
  className,
  ...props
}, ref) {
  const labelClasses = classNames(["mr-1 flex items-center"], className);
  return label ? /*#__PURE__*/React.createElement("label", {
    className: labelClasses
  }, /*#__PURE__*/React.createElement(RadioButton, _extends({}, props, {
    className: className,
    ref: ref
  })), label) : /*#__PURE__*/React.createElement(RadioButton, _extends({}, props, {
    className: className,
    ref: ref
  }));
});
RadioButton.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  // @ts-ignore
  size: PropTypes.oneOf(["small", "regular"]),
  className: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  current: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  onChange: PropTypes.func,
  noSpanClick: PropTypes.bool
};
Radio.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string
};